import { gql } from "@apollo/client";

export const GET_TIP_ITEMS = gql`
  query GetTipItems {
    getTipItems {
      id
      name
      emoji
      price
      description
      isActive
    }
  }
`;

export const GET_COIN_BALANCE = gql`
  query GetPlanyCoinWallet($userId: ID!) {
    getPlanyCoinWallet(userId: $userId) {
      userId
      balance
    }
  }
`;

export const GET_WALLET_SUMMARY = gql`
  query GetWalletSummary($userId: ID!) {
    getWalletSummary(userId: $userId) {
      totalPurchased
      totalSpent
      tipsReceived
      tipsSent
      balance
    }
  }
`;

export const GET_COIN_TRANSACTIONS = gql`
  query GetPlanyCoinTransactions($userId: ID!) {
    getPlanyCoinTransactions(userId: $userId) {
      id
      user {
        id
        username
      }
      targetUser {
        id
        username
      }
      type
      amount
      usdValue
      item
      note
      createdAt
    }
  }
`;

export const WITHDRAW_PLANY_COINS = gql`
  mutation WithdrawPlanyCoins($amount: Int!) {
    withdrawPlanyCoins(amount: $amount) {
      success # true if backend processed the withdrawal
      message # any error or confirmation text
    }
  }
`;